import { render, staticRenderFns } from "./UserHasNoActivity.vue?vue&type=template&id=ea2fcfd0&scoped=true"
import script from "./UserHasNoActivity.vue?vue&type=script&lang=ts"
export * from "./UserHasNoActivity.vue?vue&type=script&lang=ts"
import style0 from "./UserHasNoActivity.vue?vue&type=style&index=0&id=ea2fcfd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2fcfd0",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user/user-has-no-activity.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fusers%2FUserHasNoActivity.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports